/**
 * The built-in WebAdmin logo - loaded from the static SVG files in public/logo/.
 * The CRM is WebAdmin's own tool, so this is the WebAdmin mark, not the Husly
 * one the platform apps carry.
 * `variant="full"` = the wordmark (webadmin.svg), `variant="icon"` = the mark
 * only (webadmin-icon.svg), which is what the collapsed CRM sidebar shows.
 *
 * Both come as a light/dark pair because the files carry a baked-in fill: the
 * plain file is dark ink for a light background, the `-dark` file is white ink
 * for a dark one.
 *
 * nginx serves public/ as immutable, so a new drawing under the same file name
 * needs a new `?v=` here, or browsers keep showing the old logo.
 */
const V = "?v=2";
export interface LogoProps {
  variant?: "full" | "icon";
  className?: string;
}

export function Logo({ variant = "full", className }: LogoProps) {
  if (variant === "icon") {
    return (
      <>
        <img
          src={`/logo/webadmin-icon.svg${V}`}
          alt="WebAdmin"
          className={`${className || ""} dark:hidden`}
          role="img"
          draggable={false}
        />
        <img
          src={`/logo/webadmin-icon-dark.svg${V}`}
          alt="WebAdmin"
          className={`${className || ""} hidden dark:block`}
          role="img"
          draggable={false}
        />
      </>
    );
  }
  return (
    <>
      <img
        src={`/logo/webadmin.svg${V}`}
        alt="WebAdmin"
        className={`${className || ""} dark:hidden`}
        role="img"
        draggable={false}
      />
      <img
        src={`/logo/webadmin-dark.svg${V}`}
        alt="WebAdmin"
        className={`${className || ""} hidden dark:block`}
        role="img"
        draggable={false}
      />
    </>
  );
}
